import { PageConfig } from "../page-configs";
import { AlertId, getAlert } from "../alert";
import { DISCLAIMER } from "../../../global/variables";
import { getWelcomeText } from "../welcome";
import { PINK_BUTTONS } from "../../feature-buttons";

export const pageConfigPINK: PageConfig = {
    header: "Digitaler Assistent",
    alert: getAlert(AlertId.QuestionsAboutUnternehmen),
    welcome: {
        text: getWelcomeText("PINK"),
        disclaimer: DISCLAIMER,
        buttons: PINK_BUTTONS,
    },
};
